import React, { useState } from 'react';

export default function FriendlyDivisionGame() {
  const [step1, setStep1] = useState('');
  const [step2, setStep2] = useState('');
  const [step3, setStep3] = useState('');
  const [step4, setStep4] = useState('');
  const [final, setFinal] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackStyle, setFeedbackStyle] = useState({});

  const handleCheckAnswers = () => {
    const ans1 = step1.trim().toLowerCase();
    const ans2 = parseInt(step2);
    const ans3 = parseInt(step3);
    const ans4 = parseInt(step4);
    const total = parseInt(final);

    const isCorrectStep1 =
      ans1 === 'break it into parts' || ans1 === 'break into parts';
    const isCorrect =
      isCorrectStep1 && ans2 === 20 && ans3 === 20 && ans4 === 5 && total === 45;

    if (isCorrect) {
      setFeedback("🎉 You're a Division Master! 225 ÷ 5 = 45");
      setFeedbackStyle({ color: '#2e7d32' });
    } else {
      setFeedback('❌ Oops! Check your steps again.');
      setFeedbackStyle({ color: '#c62828' });
    }
  };

  const styles = {
    body: {
      fontFamily: "'Fredoka One', sans-serif",
      background: '#e1f5fe',
      margin: 0,
      padding: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
    },
    container: {
      background: 'white',
      borderRadius: 20,
      padding: '30px 40px',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
      width: '100%',
      maxWidth: 500,
      textAlign: 'center',
    },
    heading: {
      fontSize: '2rem',
      color: '#0277bd',
      marginBottom: 20,
    },
    step: {
      marginBottom: 15,
      textAlign: 'left',
    },
    label: {
      display: 'block',
      marginBottom: 6,
      fontSize: '1.1rem',
      color: '#01579b',
    },
    input: {
      width: '100%',
      padding: 10,
      fontSize: '1.1rem',
      borderRadius: 10,
      border: '2px solid #81d4fa',
      outline: 'none',
      boxSizing: 'border-box',
    },
    inputFocus: {
      borderColor: '#0288d1',
    },
    button: {
      marginTop: 20,
      padding: '12px 30px',
      backgroundColor: '#00c853',
      color: 'white',
      fontSize: '1.1rem',
      border: 'none',
      borderRadius: 10,
      cursor: 'pointer',
      transition: 'background 0.3s ease',
    },
    result: {
      marginTop: 20,
      fontSize: '1.3rem',
      ...feedbackStyle,
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>
          🎉 Friendly Numbers: <span>225 ÷ 5</span>
        </h1>

        <div style={styles.step}>
          <label style={styles.label}>🧠 Step 1: What do we say first?</label>
          <input
            type="text"
            value={step1}
            onChange={(e) => setStep1(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.step}>
          <label style={styles.label}>💡 Step 2: 100 ÷ 5 = ?</label>
          <input
            type="number"
            value={step2}
            onChange={(e) => setStep2(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.step}>
          <label style={styles.label}>🔍 Step 3: Another 100 ÷ 5 = ?</label>
          <input
            type="number"
            value={step3}
            onChange={(e) => setStep3(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.step}>
          <label style={styles.label}>🎯 Step 4: 25 ÷ 5 = ?</label>
          <input
            type="number"
            value={step4}
            onChange={(e) => setStep4(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.step}>
          <label style={styles.label}>🌟 Final Step: What is the total?</label>
          <input
            type="number"
            value={final}
            onChange={(e) => setFinal(e.target.value)}
            style={styles.input}
          />
        </div>

        <button style={styles.button} onClick={handleCheckAnswers}>
          Check Answers ✅
        </button>

        <div style={styles.result}>{feedback}</div>
      </div>
    </div>
  );
}
